export default "__VITE_ASSET__CvvpGCGz__"